import { elements, modifiers } from '../styles.js'
import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const keys = object(null, {
  async ArrowUp (
    item,
    event,
    isItemAdd
  ) {
    if (!isItemAdd) {
      preventDefault(event)
      await previous(item)
    }
  },
  async ArrowDown (
    item,
    event,
    isItemAdd
  ) {
    if (!isItemAdd) {
      preventDefault(event)
      await next(item)
    }
  },
  async ArrowLeft (
    item
  ) {
    await previous(item)
  },
  async ArrowRight (
    item
  ) {
    await next(item)
  },
  async Backspace (
    item,
    event,
    isItemAdd
  ) {
    if (isItemAdd) {
      // await previous(item)
      const { previousElementSibling } = item

      if (previousElementSibling) {
        await deleteItem(previousElementSibling)
      }
    } else {
      await deleteItem(item)
    }
  },
  async Delete (
    item,
    event,
    isItemAdd
  ) {
    if (!isItemAdd) {
      await deleteItem(item)
    }
  }
})

const onKeyDown = object(listener, {
  type: keyDown,
  task: async (
    item,
    event
  ) => {
    const { defaultPrevented, key } = event
    const itemAddField = one(`.${elements.new_field_input}`, item)
    const isItemAdd = item.matches(`.${elements.chips_add}`)

    if (defaultPrevented) {
      return
    }

    if (isItemAdd && itemAddField.value.trim() !== '') {
      return
    }

    await keys[key]?.(item, event, isItemAdd)
  }
})

const onDelete = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const item = closest(`[data-contract~="chip.item"]`, button)
    await deleteItem(item)
  }
})

const deleteItem = async (
  item
) => {
  await next(item)

  if (!(await next(item))) {
    await previous(item)
  }

  remove(item)
}

const prevNext = (
  elementSibling
) => {
  if (!elementSibling) {
    return false
  }

  const addField = one(`.${modifiers.new_field_input.new_text}`, elementSibling)
  const itemValue = one(`.${elements.chip_value}`, elementSibling)

  if (addField) {
    addField.focus()
  } else if (itemValue) {
    itemValue.focus()
  }

  return true
}

const next = async (
  item
) => {
  const { nextElementSibling } = item

  prevNext(nextElementSibling)
}

const previous = async (
  item
) => {
  const { previousElementSibling } = item

  prevNext(previousElementSibling)
}

export default item => {
  const deleteButton = one(`.${elements.chip_delete}`, item)

  if (deleteButton) {
    onDelete.listen(deleteButton)
  }

  onKeyDown.listen(item)
}
